<script setup lang="ts">
    import infoIcon from '~/assets/icons/info-white.svg';

    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();
    const shopwareDownToast = useState<any | null>('shopware-down-toast-el', () => null);

    onMounted(() => {
        if (route.query.showIntro) {
            useToast().info({
                color: '#fff',
                title: t('fachkreis.notificationHeader'),
                message: t('fachkreis.notification'),
                // @ts-expect-error new attribute, therefore not yet recognized but still works
                iconUrl: infoIcon,
                animateInside: false,
                timeout: 5500, //Should be synchronized with timeout from useNotification
                position: 'topRight',
                class: 'notification info',
                progressBarColor: 'rgb(70, 160, 175)'
            });
        }

        if (route.query.shopwareDown) {
            shopwareDownToast.value = useToast().info({
                color: '#fff',
                title: t('errors.shopwareDownToastTitle'),
                message: t('errors.shopwareDownToastMessage'),
                // @ts-expect-error new attribute, therefore not yet recognized but still works
                iconUrl: infoIcon,
                animateInside: false,
                timeout: false,
                position: 'topRight',
                class: 'notification info shopware-down-toast',
                progressBar: false
            });
        }

        if (route.query.docebo_session_error) {
            useToast().info({
                color: '#fff',
                title: t('academy.doceboAuthErrorToastTitle'),
                message: t('academy.doceboAuthErrorToastMessage'),
                // @ts-expect-error new attribute, therefore not yet recognized but still works
                iconUrl: infoIcon,
                animateInside: false,
                timeout: false,
                position: 'topRight',
                class: 'notification info',
                progressBar: false
            });

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { docebo_session_error, ...remainingQuery } = route.query;
            router.replace({
                path: route.path,
                query: remainingQuery,
                hash: route.hash
            });
        }
    });
</script>

<!-- We need a template block for the component to be valid -->
<template>
    <slot />
</template>

<style lang="scss">
    @import '~/assets/scss/basics/toast-override.scss';
</style>
